import * as React from 'react';
import { HUB_URL } from '@/config';
import { createSignalRContext } from "react-signalr/signalr";
import { configureSignalRConnection, logSignalRError, sendSignalRMessage } from '@/lib/signalr';
import storage from '@/utils/storage';
import { getDisplayCodeFromUrl } from '@/utils/displayCode';
import { HubConnection, HubConnectionState } from '@microsoft/signalr';

const SignalRContext = createSignalRContext();

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  const displayCode = getDisplayCodeFromUrl();
  const deviceId = displayCode ? '' : storage.getDeviceId();

  const connectDisplay = (connection: HubConnection) => {
    configureSignalRConnection(connection);

    if (connection.state !== HubConnectionState.Connected) {
      return;
    }

    if (displayCode) {
      void sendSignalRMessage(connection, 'DisplayConnectByCode failed', 'DisplayConnectByCode', displayCode);
    } else if (deviceId) {
      void sendSignalRMessage(connection, 'DisplayConnect failed', 'DisplayConnect', deviceId);
    }
  };

  return (
    <SignalRContext.Provider
      logMessageContent
      onOpen={connectDisplay}
      onReconnect={connectDisplay}
      onClosed={(error?: Error) => {
        logSignalRError('Display hub closed', error);
      }}
      onError={async (error?: Error) => {
        logSignalRError('Display hub connection error', error);
      }}
      automaticReconnect
      connectEnabled
      url={HUB_URL}
      dependencies={[deviceId, displayCode]}
    >
      {children}
    </SignalRContext.Provider>
  );
};

export { SignalRContext };
